export const SET_USER_STATE = 'SET_USER_STATE';
export const SET_CREDIT_LIMIT = 'SET_CREDIT_LIMIT';
export const SET_LOAN_AMOUNT = 'SET_LOAN_AMOUNT';
export const SET_EMI_PLAN = 'SET_EMI_PLAN';
export const SET_PERSONAL_DETAILS = 'SET_PERSONAL_DETAILS';
export const SET_BANK_PARTNER = 'SET_BANK_PARTNER';
export const SET_CREDIT_LINE_STATE = 'SET_CREDIT_LINE_STATE';
export const SET_CREDIT_LINE_LOAN_ID = 'SET_CREDIT_LINE_LOAN_ID';
export const FROM_ADDRESS_DETAIL_PAGE = 'FROM_ADDRESS_DETAIL_PAGE';
